export default __webpack_public_path__ + "static/media/music.93142ad8.mp3";